import './Miusics.css'
const Miusics=({ID ,MiusicsIMG , MiusicsTitle , MiusicsDescribtion ,MiusicAdress})=>{
    return(
        <div className="MiusucsDiv" key={ID}>
            <img src={MiusicsIMG} alt={MiusicsTitle} className="MiusicsIMG" />
            <h1>{MiusicsTitle}</h1>
            <p>
                {MiusicsDescribtion.split('\n').map((line, index) => (
                    <span key={index}>
                        {line}
                        <br />
                    </span>
                ))}
            </p>
            <audio controls>
                <source src={MiusicAdress} type="audio/mpeg" />
                Your browser does not support the audio element.
            </audio>
        </div>
    )
}


export default Miusics